import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Column, TextField, Typography } from 'seagull';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
import { withoutMinusSign } from './AiFilterChip.utils';
export const NumberRangeChip = (param)=>{
    let { testId, fieldLabel, value, valueLabel, valueSegments, combinator, operator, valuePrefix, suffix, tone, editable = true, validate, onApply, onRemove, biPrefix, autoOpen = false, texts } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const [draft, setDraft] = useState(value);
    const [error, setError] = useState(null);
    const resetDraft = ()=>{
        setDraft(value);
        setError(null);
    };
    const applied = ()=>{
        const trimmed = draft.trim();
        if (validate != null && !validate(trimmed)) {
            var _texts_validationError;
            setError((_texts_validationError = texts.validationError) !== null && _texts_validationError !== void 0 ? _texts_validationError : '');
            return false;
        }
        onApply(trimmed);
        return true;
    };
    return /*#__PURE__*/ _jsx(AiChipShell, {
        testId: testId,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        operator: operator,
        valuePrefix: operator == null ? valuePrefix : undefined,
        valueLabel: valueSegments == null ? valueLabel : undefined,
        valueSegments: valueSegments,
        combinator: valueSegments == null ? undefined : combinator,
        tone: tone,
        interactive: editable,
        applyText: texts.apply,
        onOpen: resetDraft,
        onApply: applied,
        onRemove: onRemove,
        children: (param)=>{
            let { apply } = param;
            return /*#__PURE__*/ _jsxs(Column, {
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(TextField, {
                        testId: testIds.AiFilterChipTestIds.EditTextField(),
                        bi: {
                            name: "".concat(biPrefix, "_edit")
                        },
                        fullWidth: true,
                        value: draft,
                        placeholder: texts.placeholder,
                        suffix: suffix,
                        onChange: (event)=>{
                            setDraft(withoutMinusSign(event.target.value));
                            setError(null);
                        },
                        inputProps: {
                            onKeyDown: (event)=>{
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    apply();
                                }
                            }
                        },
                        autoFocus: true
                    }),
                    error != null && error !== '' && /*#__PURE__*/ _jsx(Typography, {
                        testId: testIds.AiFilterChipTestIds.ValidationError(),
                        skin: "error",
                        variant: "paragraph2",
                        children: error
                    })
                ]
            });
        }
    });
};
